export const selectedProduct = state => state.product?.selectedProduct;

const initialState = {};

const productReducers = (state = initialState, action) => {
  if (action.type === `RESET_PRODUCT`) {
    return initialState;
  }

  if (action.type === `SET_SELECTED_PRODUCT`) {
    return {
      ...state,
      selectedProduct: action.payload
    };
  }
  return state;
};

export default productReducers;
